// extracted by mini-css-extract-plugin
export default {"main":"TipoPruebaSelector_main__FqYkn"};